import React from "react";

import { Link } from "react-router-dom";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";
import Option from "../../common/RowOption";

const CreditorList = ({ data, query }) => {
  const renderLink = (e) => {
    return (
      <Link
        to={`/mis/creditor/${e.creditor_id}/profile/finance?creditorName=${e.name}`}
      >
        {e.name}
      </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "photo",
      label: "عکس",
      content: ({ photo }) => <RowPhoto src={photo} />,
    },
    {
      path: "name",
      label: "بدهکار",
      content: (e) => renderLink(e),
    },
    {
      path: "phone",
      label: "شماره تماس",
    },
    {
      path: "aria_id",
      label: "کد بدهکار",
    },
    {
      path: "payable",
      label: "قابل پرداخت",
    },
    {
      path: "paid",
      label: "پرداخت شده",
    },
    {
      path: "balance",
      label: "باقیمانده",
    },
    {
      path: "overall_balance",
      label: "باقیمانده کل",
    },

    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{ form: "creditor-form", cache: e.creditor_id, edit: e }}
          Delete={{ route: "creditors", id: e.creditor_id }}
        />
      ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default CreditorList;
